import styled from "styled-components";
import {ProfileCard, ProfileListProps, SkillTag} from "@betrue/ui";
import {Profile, Skill, StyledBaseProps} from "@betrue/shared/interfaces";
import {Box, FormControlLabel, Grid, Switch, TextField, Typography} from "@mui/material";
import {UserRatingView} from "../user-rating/user-rating.view";

interface ProfileListViewProps extends ProfileListProps, StyledBaseProps {
  profiles: Profile[],
  completedOnly: boolean,
  onCompletedOnlyChange: (b: boolean) => void,
  onFilter: (t: string) => void,
  searchTerm: string,
  availableSkills: Skill[],
  onAddSkill: (skill: Skill) => void,
  onRemoveSkill: (skill: Skill) => void,
  filterSkillMap: any,
  showRating: boolean,
  onRatingFilterChange: (newValue: number) => void
}


export const ProfileListView = styled((props: ProfileListViewProps) => (
  <div className={props.className}>
    <Grid container direction={'row'} spacing={2} alignItems={'center'} alignContent={'center'}>
      <Grid item sm={8} xs={12} lg={8}>
        <TextField fullWidth label="nom prénom, metier, compétence..."
                   value={props.searchTerm}
                   onChange={(e) => props.onFilter(e.target.value)}
                   variant="outlined"/>
      </Grid>
      <Grid item sm={4} xs={12} lg={4}>
        <FormControlLabel
          control={
            <Switch
              checked={props.completedOnly}
              onChange={e => props.onCompletedOnlyChange(e.target.checked)}
              name="completedProfilesOnly"
              inputProps={{'aria-label': 'secondary checkbox'}}
            />
          }
          label="Profils complétés à plus 80%"
        />
      </Grid>

    </Grid>
    <Grid container direction={'row'} spacing={2} alignItems={'flex-start'} alignContent={'center'}>
      {props.profiles.length ?
        <Grid item sm={8} xs={12} lg={8}>
          <Grid container direction={'row'} spacing={2}>
            {props.profiles.map((profile) => (
              <Grid key={profile.id} item sm={6} xs={12} lg={4}>
                <ProfileCard profile={profile} person={profile.person}/>
              </Grid>))}
          </Grid>
        </Grid>
        : <Grid item sm={8} xs={12} lg={8}><Typography
          variant={'h4'}>{props.noProfilesLabel ? props.noProfilesLabel : 'Aucun profil'} 🙄</Typography>
        </Grid>}
      <Grid item sm={4} xs={12} lg={4}>
        {props.showRating ? (
          <Box component="fieldset" mb={3} borderColor="transparent">
            <Typography component="legend">Avis</Typography>
            <UserRatingView onRating={props.onRatingFilterChange} readOnly={false} defaultValue={2}/>
          </Box>) : ''}
        <Grid container direction={"row"} spacing={0} alignContent={'flex-start'} alignItems={'stretch'}>
          {props.availableSkills.map(skill => (props.filterSkillMap && props.filterSkillMap[skill.key] ?
            <SkillTag key={skill.id} skill={skill} className={"active"} onDelete={props.onRemoveSkill}/> :
            <Grid item> <SkillTag key={skill.id} skill={skill} onAdd={props.onAddSkill}/></Grid>))}
        </Grid>
      </Grid>
    </Grid>

  </div>
))`
  & .bt-no-profiles {
    color: ${props => props.theme.colors.text};
  }

`
